
// https://marcoroth.dev/posts/guide-to-custom-turbo-stream-actions

import { toast } from './stream_actions/toast.js'

export function setup(StreamActions) {
  StreamActions.toast = toast
}
